import { ApiError } from "@carepass/api-client";

export const isDuplicateSignup = (cause: unknown) => cause instanceof ApiError && cause.code === "PARTNER_MEMBER_DUPLICATED";

// This is only a one-time form prefill, never an authentication credential.
const key = "carepass.signup.login-phone";
export const saveSignupLoginPhone = (phone: string) => sessionStorage.setItem(key, phone.replace(/\D/g, "").slice(0, 11));
export const readSignupLoginPhone = () => sessionStorage.getItem(key) ?? "";
export const clearSignupLoginPhone = () => sessionStorage.removeItem(key);
